// get users
const FETCH_USERS = 'get_user_data'
const LOAD_USERS_DATA = 'load_service_data'
const UPDATE_USER = 'update_user'

// new user
const LOAD_CREATEDUSER = '🙋‍♂️ Load newUser'
const CREATE_USER_PENDING = '🕐 Create user pending'
const CREATE_USER_SUCCESS = '✅ Create user success'
const CREATE_USER_FAILURE = '❌ Create user failure'

const UPDATE_PARAMS = '✨ update_params'

export default {
  LOAD_CREATEDUSER,
  CREATE_USER_FAILURE,
  CREATE_USER_PENDING,
  CREATE_USER_SUCCESS,
  UPDATE_USER,
  LOAD_USERS_DATA,
  FETCH_USERS,
  UPDATE_PARAMS,
}
